import 'pages/Ocf/style/Ocf.scss';
import './components/WhatsChanged.style.scss';
import Label from 'components/form/Label/Label';
import SectionContainer from 'components/Containers/SectionContainer';
import { TitleContainer } from 'components/Containers/TitleContainer/TitleContainer';
import { Row } from 'components/Containers/Row/Row';
import OfferCarouselContainer from 'partial/OfferManager/OfferCarouselContainer';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';
import DifferentialText from 'components/DifferentialText';
import { OCF_WHATS_CHANGED_OFFERS } from 'types/morph.pagePosition.constants';

import { CreditInfoTable } from './components/CreditInfoTable';
import { monthsToYears } from 'helpers/dateHelper';
import PageContainer from 'components/Containers/PageContainer';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import UnifiedCCOffersContainer from 'partial/OfferManager/UnifiedCCOffersContainer';
import MoreWaysToBrowseCard from 'pages/Ocf/components/MoreWaysToBrowseCard';

const WhatsChangedOcfView = props => {
  const {
    creditProfile,
    whatsChangedMeta,
    defaultTestId,
    offers,
    isOcfPage,
    eventHandler,
    partnersCustomTrackingMeta,
    containerType,
    modulePosition,
    optimizelyExperimentObj,
    seenPixel,
    showUnifiedSecuredTemplate,
  } = props;

  const { creditScore, creditAge } = whatsChangedMeta;
  const currentAge =
    creditAge.current !== '--' ? monthsToYears(creditAge.current) : '--';

  const subTitle =
    creditScore?.difference !== 0 ? (
      <>
        {'Based on '}
        <DifferentialText
          datatestid="creditscore-table-diff"
          {...creditScore}
          fontSizeClass="text-12"
        />
        {"  we've updated your approval odds to help better your credit!"}
      </>
    ) : (
      <span>
        Based on your score we've updated your approval odds to help better your
        credit!
      </span>
    );

  return (
    <>
      <PageContainer datatestid={`${defaultTestId}-container`}>
        {seenPixel}
        <SectionContainer datatestid={`${defaultTestId}`}>
          <Row className="headerSection">
            <div className="header-container">
              <TitleContainer className="simulationNewCardTitle">
                <Label
                  type="H3 ocfTitleLabel"
                  datatestid={`${defaultTestId}-title`}
                >
                  Your score has changed!
                </Label>
              </TitleContainer>
            </div>
          </Row>

          <CreditInfoTable
            {...whatsChangedMeta}
            currentAge={currentAge}
            creditInfo={creditProfile}
          />
          <Row className="copyTextRow">
            <Label className="text-16 fontGray400 copyText bold">
              {subTitle}
            </Label>
          </Row>

          <Row fullWidth className="ocfDisclaimer margT32 margLR48 m-margLR0">
            <Disclaimer showPartnerText />
          </Row>
          {showUnifiedSecuredTemplate ? (
            <FlexContainer className={'flex-column'}>
              <UnifiedCCOffersContainer
                datatestid={`${defaultTestId}-unifiedCCOffers`}
                offers={offers}
                pagePosition={OCF_WHATS_CHANGED_OFFERS}
                isOcfPage={isOcfPage}
                eventHandler={eventHandler}
                partnersCustomTrackingMeta={partnersCustomTrackingMeta}
                containerType={containerType}
                modulePosition={modulePosition}
                optimizelyExperimentObj={optimizelyExperimentObj}
                showSeeMoreCardsLink={false}
              />
            </FlexContainer>
          ) : (
            <Row
              type="carousel"
              datatestid={`${defaultTestId}-offersCarousel`}
              className={`${defaultTestId}-offersCarousel hideSubHeader`}
            >
              <OfferCarouselContainer
                extraAttributes={{ pagePosition: OCF_WHATS_CHANGED_OFFERS }}
                {...props}
              />
            </Row>
          )}
        </SectionContainer>
      </PageContainer>
      <MoreWaysToBrowseCard />
    </>
  );
};

export default WhatsChangedOcfView;
